import { render } from "./vertical.vue?vue&type=template&id=3a485d41&scoped=true"
import script from "./vertical.vue?vue&type=script&lang=js"
export * from "./vertical.vue?vue&type=script&lang=js"

import "./vertical.vue?vue&type=style&index=0&id=3a485d41&scoped=true&lang=css"

import exportComponent from "D:\\Project\\crosstechno\\crm-frontend-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a485d41"]])

export default __exports__